import React, {Component} from 'react';
import {Col, FormGroup, Label, Input} from 'reactstrap';

class FormText extends Component {
	render() {
		let displayLabel = this.props.humanLabel;
		if (this.props.dbView) {
			displayLabel = this.props.label;
			if (this.props.parentID) {
				displayLabel = `${this.props.parentID.split("-")[0]}.${this.props.label}`;
			}
		} 
		let textInput = (<Input
			id={`${this.props.parentID}-${this.props.label}`}
			className="rounded-0 textinput"
			type="text"
			onChange={this.props.triggerFormValueChange}
			value={this.props.value}
			disabled={this.props.disabled}
		/>)
		if (this.props.maxLength) {
			textInput = (<Input
				id={`${this.props.parentID}-${this.props.label}`}
				className="rounded-0 textinput"
				type="text"
				onChange={this.props.triggerFormValueChange}
				value={this.props.value}
				disabled={this.props.disabled}
				maxLength={255}
			/>)
		}
		return (
			<Col xs={this.props.colsize} className={this.props.className}>
				<FormGroup>
					<Label
						className="simpleLabel"
						for={`${this.props.parentID}-${this.props.label}`}
					>
						{displayLabel}{' '}
					</Label>
					{textInput}
				</FormGroup>
			</Col>
		);
	}
}

export default FormText;



// WEBPACK FOOTER //
// ./src/components/FormText.js